import {observer} from "mobx-react";
import React from "react";
import {FrontlineCheckbox} from "../../../Shared/FrontlineCheckbox";
import {useStores} from "../../../../Hooks";
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import {
    WorkspaceOptionsPicker
} from "../../../Domain/SubWorkspaceManagment/SubWorkapaceSettings/generalSettings/WorkspaceOptionsPicker";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {SelectPeriodicValues} from "./SelectPeriodicValues";
import {DateInput} from "./DateInput";

export const AutomateReporting = observer(({autoReportSetting}) => {
    const {workspaceManagementStore, modalStore} = useStores();
    const settings = workspaceManagementStore.editedSubDomainReportsSettings[autoReportSetting];
    const attachedUserSettings = {
        formattedValue: settings.AttachedUserEmail?.Email ?? null,
        settingsAction: {
            searchPlaceHolder: 'Search admin user',
            Icon: null,
            handleSelect: (item) => {
                settings.AttachedUserEmail = item.value;
                modalStore.isGenericSelectSearchModalOpen = false;
            },
            handleNoResult: null,
            noResultText: '',
            list: workspaceManagementStore.adminUsers,
        },
        title: null,
        placeholder: 'Attached user',
        value: settings.AttachedUserEmail,
        Icon: (handleOpenSelectModal) => (
            <KeyboardArrowDownIcon sx={{color: 'var(--main-normal-color)', fontSize: '24px', cursor: 'pointer'}}
                                   onClick={(e) =>
                                       handleOpenSelectModal(e)}/>),
    }

    const periodicProps = {
        dayValue: settings.DayValue,
        monthValue: settings.MonthValue,
        weekValue: settings.WeekValue,
        frequency: settings.Frequency,
        periodType: settings.PeriodType,
        setWeekValue: (newValue) => {
            settings.WeekValue = newValue
        },
        setMonthValue: (newValue) => {
            settings.MonthValue = newValue
        },
        setDayValue: (newValue) => {
            settings.DayValue = newValue
        },
        setFrequency: (newValue) => {
            settings.Frequency = newValue
        },
        setPeriodType: (newValue) => {
            settings.PeriodType = newValue
        },
    };
    const dateSettings =[
        {
            title: 'Start date',
            value: workspaceManagementStore.editedSubDomainReportsSettings.AutomaticUserReport.StartDay,
            onChange: (newValue) => {
                workspaceManagementStore.editedSubDomainReportsSettings.AutomaticUserReport.StartDay = newValue;
            },
            type: 'date',
            minDate :0,
        },
        {
            title: 'End date',
            value: workspaceManagementStore.editedSubDomainReportsSettings.AutomaticUserReport.EndDay,
            onChange: (newValue) => {
                workspaceManagementStore.editedSubDomainReportsSettings.AutomaticUserReport.EndDay = newValue;
            },
            type: 'date',
            minDate: 1,
        }
    ]
    return (
        <div className="flex-col w-full">
            <div className="flex w-full flex-row gap-1 font-normal justify-between mb-2">
                <div className="flex flex-row gap-1">
                    <FrontlineCheckbox isChecked={settings.IsOn} onChange={()=>settings.IsOn = !settings.IsOn } size={35} />
                    <div className="mt-2">Automate reporting</div>
                </div>
                <ConditionalComponent if={settings.IsOn} >
                    <div className="h-8 border-2 border-nav-normal rounded-3 flex flex-row items-center justify-between px-2" style={{width:'183px'}}>
                        <WorkspaceOptionsPicker settings={attachedUserSettings}/>
                    </div>
                </ConditionalComponent>
            </div>
            <ConditionalComponent if={settings.IsOn} >
                <div className="flex flex-row w-full gap-1 font-normal border-t-2 border-t-nav-normal justify-between mb-2">
                    <SelectPeriodicValues {...periodicProps} />
                    <div className="flex-col gap-20 mt-2">
                        {dateSettings.map((dateSetting) => (
                            <DateInput settings={dateSetting} />
                        ))}
                    </div>
                </div>
            </ConditionalComponent>
        </div>
    )
})